module.exports = __webpack_public_path__ + "img/course86_summary_unit_timelines.3a206b58.png";